export default __webpack_public_path__ + "static/media/fuel-icon.ddd02fbd.svg";